<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-lg-flex" style="margin-left:6px;font-size: 12px;">
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        variant="flat-primary"
        size="sm"
        class="pl-0 pr-0"
      >
        <feather-icon
          icon="HomeIcon"
          class="mr-50"
          size="14"
        />
        <span class="align-middle" @click="backToHall">返回大厅</span>
      </b-button>
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <b-dropdown
        v-ripple.400="'rgba(186, 191, 199, 0.15)'"
        :text="roleName"
        variant="flat-secondary"
      >
        <b-dropdown-item v-for="role in userData.roles" :key="role.roleCode" @click="switchRole(role)">
          {{ role.name }}
        </b-dropdown-item>
      </b-dropdown>
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{ userData.id }}
            </p>
            <span class="user-status">{{ userData.fullName }}</span>
          </div>
          <b-avatar
            size="40"
            variant="primary"
            :text="userData.fullName && userData.fullName.length > 1 ? userData.fullName.substring(userData.fullName.length-2,userData.fullName.length): userData.fullName"
          />
        </template>
        <b-dropdown-item link-class="d-flex align-items-center" @click="logout">
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span>登出</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav, BNavItemDropdown, BDropdownItem, BAvatar,
} from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import { backToHall } from '@/tool/utils'
import { switchRole, getUserInfo } from '@/api/api'
import { initialAbility } from '@/libs/acl/config'
import { avatarText } from '@core/utils/filter'
import { getUserRole } from '@/auth/utils'
import Vue from 'vue'

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BAvatar,

    // Navbar Components
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {
      },
    },
  },
  data() {
    return {
      userData: {},
      getUserRole,
      avatarText,
    }
  },
  mounted() {
    this.loadUserInfo()
  },
  methods: {
    backToHall,
    switchRole(role) {
      switchRole(role.roleCode)
        .then(rep => {
          if (rep.status) {
            this.$success('角色切换成功')
            // eslint-disable-next-line no-restricted-globals
            location.reload()
            // login().then(() => this.loadUserInfo())
          }
        })
    },
    loadUserInfo() {
      getUserInfo()
        .then(res => {
          if (res.status) {
            const { userData, accessToken, refreshToken } = res.data
            if (userData && typeof (userData) !== 'undefined') {
              localStorage.setItem('userData', JSON.stringify(userData))
              const validAbility = []
              if (userData.ability) {
                validAbility.push(...userData.ability.filter(item => item.subject))
              }
              validAbility.push(...initialAbility)
              Vue.prototype.$ability.update(validAbility)
            }
            useJwt.setToken(accessToken)
            useJwt.setRefreshToken(refreshToken)

            this.userData = userData

            if (this.userData) {
              if (this.userData.roles && this.userData.roles.length > 0 && this.userData.role) {
                this.roleName = this.userData.roles.find(role => role.roleCode === this.userData.role).name
              }
            }
          }
        })
    },
    async logout() {
      localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
      localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)

      // Remove userData from localStorage
      localStorage.removeItem('userData')

      // Reset ability
      this.$ability.update([])

      // Redirect to login page
      window.location.href = 'https://talent.whut.edu.cn/index.html#/login'
    },
  },
}
</script>
